module.exports = __webpack_public_path__ + "img/text.b4d26a01.png";